import { render, staticRenderFns } from "./WorkspaceHeader.vue?vue&type=template&id=726d79fa&scoped=true&"
import script from "./WorkspaceHeader.vue?vue&type=script&lang=js&"
export * from "./WorkspaceHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceHeader.vue?vue&type=style&index=0&id=726d79fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d79fa",
  null
  
)

export default component.exports